<template>
    <div class="productPage">
      <div v-if="this.$store.state.webNavigator=='pc'">
        <div class="news-list">
          <div class="font44px" style="margin: 40px 0 29px 0;text-align: center">
            全线产品
          </div>
          <div
            class="news-list-bar displayIB pointEr"
            :class="(index+1)%4==0?'news-list-last-bar':''"
            v-for="(item , index) in productList" :key="index"
            @click="gotoInfo(item)"
          >
            <div>
              <img
                class="news-list-img"
                :src="httptype(item.themeImg)"
                :alt="item.tag?item.tag:''" title=""/>
            </div>
            <div class="news-list-Text displayIB">
              <p class="font16px col33333 news-list-Tlt overflowText">{{item.title}}</p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="this.$store.state.webNavigator=='phone'">
        <div class="phoneProduct-list">
          <div class="font36phone" style="margin: 40px 0 29px 0;text-align: center">
            全线产品
          </div>
          <div
            class="phoneProduct-bar displayIB pointEr"
            :class="(index+1)%4==0?'news-list-last-bar':''"
            v-for="(item , index) in productList" :key="index"
            @click="gotoInfo(item)"
          >
            <div>
              <img
                class="phoneProduct-img"
                :src="httptype(item.themeImg)"
                :alt="item.tag?item.tag:''" title=""/>
            </div>
            <div class="phoneProduct-Text displayIB">
              <p class="font24phone col33333 phoneProduct-Tlt overflowText">{{item.title}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>

import config from '@/others/interface';
import {$get, $post, } from '@/others/ajax';
import { myFun } from '../../../plug/modifyImagePath'
export default {
  name: 'productPage',
  components: {
  },
  props: {
    pageIndex: {
      type: Number,
      default: null,
    },
  },
  data () {
    return {
      current: 1,
      imgUrl: 'https://jusexcx.zmelo.com/',
      productList: [],
      total: 1,
    };
  },
  watch: {},
  methods: {
    getList () {
      $get(config.zmlgw + '/web/productList', {
        page: this.pageIndex,
        pageSize: this.pageType == true ? '9' : '6',
      }).then((res) => {
        if (res.code == 200) {
          this.productList = res.data.rows;
          this.$emit('getTotal', res.data.count);
        }
      });
    },
    httptype (url) { // 图片判断
      if (url) {
        url.toString();
        if (url.indexOf('http') == '-1') {
          return this.imgUrl + url;
        } else {
          return myFun(url);
        }
      }
    },
    gotoInfo (item) {
      this.$router.push({path: '/productInfo/' + item.id + '/' + item.title + '.html', });
    },
  },
  asyncData ({store, route, app, }) {

  },
  mounted () {
  },
  beforeDestroy () {
  },
  computed: {},
  created () {
    this.getList();
  },
  filters: {},
};
</script>

<style lang="less" scoped>
  @media screen and (max-width: 800px) {
    @import url('../../productList/productPage/productPagePhone');
  }
  @media screen and (min-width: 800px) {
    @import url('../../productList/productPage/productPage');
  }
</style>



// WEBPACK FOOTER //
// productPage.vue